import * as React from "react";

// NPM
import clsx from "clsx";
import { animated } from "react-spring";
import moment from "moment";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { FormControlLabel, Grid, GridProps, Checkbox } from "@material-ui/core";

// Utility
import Utility from "../../domain/classes/Utility";

// Components
import FormattedFieldSet from "../common/FormattedFieldSet.Component";

// Contexts
import { useApplicationManager } from "../../contexts/ApplicationManager.Context";

// Classes
import { Alert } from "@material-ui/lab";

export const styles = (theme: Theme) => createStyles({ root: {} });

export interface TelehealthCheckboxContainerProps extends GridProps {
	onTelehealthRestrictionAcknowledgedChange: (value: boolean) => void;
	isTelehealthRestrictionAcknowledged: boolean;
}

const TelehealthCheckboxContainer = React.forwardRef<
	HTMLDivElement,
	TelehealthCheckboxContainerProps & WithStyles<typeof styles>
>(
	(
		{
			classes,
			className,
			onTelehealthRestrictionAcknowledgedChange,
			isTelehealthRestrictionAcknowledged,
			...gridProps
		},
		ref
	) => {
		const { handlePatientDetailsChange } = useApplicationManager();

		const handleChange = (
			event: React.ChangeEvent<HTMLInputElement>,
			checked: boolean
		) => {
			handlePatientDetailsChange(
				"telehealthRestrictionAcknowledged",
				checked
			);
			onTelehealthRestrictionAcknowledgedChange(checked);
		};

		return (
			<Grid
				container
				spacing={1}
				ref={ref}
				{...gridProps}
				className={clsx(classes.root, className)}
			>
				<Grid item xs={12}>
					<FormattedFieldSet label="Telehealth restriction">
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Alert severity="warning">
									<FormControlLabel
										control={
											<Checkbox
												checked={
													isTelehealthRestrictionAcknowledged
												}
												name="telehealthRestrictionCheckbox"
												color="primary"
												onChange={handleChange}
											/>
										}
										label="Medicare rebate only applies to patients who
								have attended the clinic in person in the last
								12 months."
									/>
								</Alert>
							</Grid>
						</Grid>
					</FormattedFieldSet>
				</Grid>
			</Grid>
		);
	}
);

const StyledTelehealthCheckboxContainer = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("TelehealthCheckboxContainer"),
})(TelehealthCheckboxContainer);

export default StyledTelehealthCheckboxContainer;

export const AnimatedTelehealthCheckboxContainer = animated(
	StyledTelehealthCheckboxContainer
);
